import styled from 'styled-components';

export const CtaBar = styled.div`
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 999;
  height: 56px;
  background: var(--gradient-gold);
  box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.3);
  display: flex;
  align-items: center;
  justify-content: center;

  @media (min-width: 769px) {
    display: none;
  }
`;

export const CtaLink = styled.a`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  width: 100%;
  height: 100%;
  color: #fff;
  text-decoration: none;
  font-family: var(--font-heading);
  font-weight: 700;
  font-size: 1rem;
  letter-spacing: 0.5px;

  &:hover,
  &:focus {
    color: #fff;
    text-decoration: none;
  }

  &:active {
    opacity: 0.9;
  }
`;

export const CtaIcon = styled.span`
  display: flex;
  align-items: center;
  font-size: 1.1rem;
`;
